export default __webpack_public_path__ + "static/media/professorRecording.27a55128.mp3";